import {
  Alignment,
  Button,
  Classes,
  Dialog,
  HTMLSelect,
  HTMLTable,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalc, IContestacaoCalc, IContestacaoLote, IEmpresa, IMva, IProduto } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { CalcStore } from "../../stores/calculo/CalcStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { getMomentFormatter } from "../../utils";
import { FormGroup } from "@blueprintjs/core";
import MomentLocaleUtils from "react-day-picker/moment";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import { toast } from "react-toastify";
import { MDBCol, MDBRow } from "mdbreact";
import { GenerateCalcOptions } from "./calcs_options";
import { CalcSelect, filterCalcs, renderCalcs } from "../utils/CalcSelect";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

var debounce = require('lodash.debounce');

interface ContestarLoteDialogProps {
  items: IContestacaoCalc[];
  tipo: string;
  empresaSelecionada: IEmpresa;
  modelo: string;
  onClose: (reload?: boolean) => void;
}

interface ContestarLoteDialogState {
  loading: boolean
}

@observer
export class ContestarLoteDialog
  extends React.Component<ContestarLoteDialogProps, ContestarLoteDialogState> {

  obs = observable({
    contestacao: {} as IContestacaoLote,
    info_calculo: {} as ICalc,
    contestarAll: false as boolean,
    alertContestarAll: false as boolean,
    memoria_salvar: false as boolean,
    retroativas: true as boolean,
    aplicar_retencao: false as boolean,
    alterar_data: false as boolean,
    isDevolucao: false,
    calc_selecionado: null,
    calc_devolucao_selecionado: null,
    cnpj_memoria: true as boolean,
    open_ajuda: false as boolean,

    mudar_mva: false as boolean,
    mva_selected: null as IMva,
    loading: false as boolean,
    filter: "" as string,
    page: 1 as number,
    hasMore: true as boolean,
    options: [] as IMva[],
    fetchOptions: {} as any
  })

  constructor(props: any) {
    super(props);

    this.obs.fetchOptions = debounce(this.fetchOptions.bind(this), 800);

    this.state = {
      loading: false
    }

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {
      CalcRSStore.load();

    } else {
      CalcStore.load();
    }

    this.obs.contestacao = observable({
      nota_item_ids: this.props.items?.map(value => value["id"]),
      motivo: "",
      contestacao_calc_id: null,
      contestacao_data: null,
      entrada_saida: this.props.tipo.toLocaleLowerCase(),
      modelo: this.props.modelo.toLowerCase(),
    });

    this.fetchOptions("", 1);

  }

  handleValid() {

    if (this.obs.alterar_data) {

      if (!this.obs.contestacao.contestacao_data) {
        return true
      }

    } else {

      if (!this.obs.calc_selecionado) {
        return true
      }

    }

    if (!this.obs.contestacao.motivo) {
      return true
    }

    return false

  }

  handleContestarData(e) {
    this.obs.alterar_data = e

    this.obs.contestacao.contestacao_calc_id = null
    this.obs.contestacao.contestacao_calc_id_devolucao = null
    this.obs.contestacao.contestacao_produto_id = null

    this.obs.calc_devolucao_selecionado = null
    this.obs.calc_selecionado = null

    this.obs.memoria_salvar = false
    this.obs.cnpj_memoria = false
    this.obs.aplicar_retencao = false
  }

  handleConfirm = async () => {

    try {

      if(this.obs.mudar_mva){

        if (!this.obs.mva_selected) {
          toast.warning('Por favor, selecione um produto.', {});
          ResultadoStore.obs.working = false
          return;
        }

        if (!window.confirm("Você está selecionando um produto diferente do informado na nota. O MVA aplicado será referente ao produto selecionado.")) {
          ResultadoStore.obs.working = false
          return
        }

        this.obs.contestacao.contestacao_produto_id = this.obs.mva_selected.id

      } else {

        this.obs.contestacao.contestacao_produto_id = null

      }

      ResultadoStore.obs.working = true
      ResultadoStore.obs.ids_contestacao_all = []
      ResultadoStore.obs.itemsAllCount = 1

      if (ResultadoStore.obs.contestar_todos && !ResultadoStore.obs.notasRetroativas && !ResultadoStore.obs.notasDivergentes && !ResultadoStore.obs.notasManual) {
        this.obs.contestacao.nota_item_ids = []
        this.obs.contestacao.entrada_saida = ""

        await ResultadoStore.query_all_itens_pages(
          this.props.empresaSelecionada,
          [ResultadoStore.obs.date_start, ResultadoStore.obs.date_end],
          ResultadoStore.obs.icmsClassFilter,
          this.props.tipo,
          this.props.modelo,
          ResultadoStore.obs.filters
        )

        this.obs.contestacao.nota_item_ids = [...ResultadoStore.obs.ids_contestacao_all]

        if (!window.confirm("Você está prestes a contestar " + this.obs.contestacao.nota_item_ids.length + " itens." + "\nObs: Itens que já estão em processo são ignorados!")) {
          ResultadoStore.obs.working = false
          this.props.onClose()
          return
        }

        this.obs.contestacao.nota_item_ids?.map((el, index) => {
          this.obs.contestacao.entrada_saida = this.props.tipo.toLowerCase()
        })
        ResultadoStore.obs.ids_contestacao_all = []
        ResultadoStore.obs.itemsAllCount = 1
      }

      let devolucao = false

      if (this.obs.aplicar_retencao) {

        if (!this.obs.calc_devolucao_selecionado._id) {
          toast.warning('Por favor, selecione um cálculo para a retenção.', {});
          ResultadoStore.obs.working = false
          return;
        }

        this.obs.contestacao.contestacao_calc_id_devolucao = this.obs.calc_devolucao_selecionado._id
        this.obs.contestacao.contestacao_calc_id = this.obs.alterar_data ? null : this.obs.calc_selecionado._id

        devolucao = true

      } else {

        delete this.obs.contestacao.contestacao_calc_id_devolucao
        this.obs.contestacao.contestacao_calc_id = this.obs.alterar_data ? null : this.obs.calc_selecionado._id

        devolucao = false

      }

      await ResultadoStore.create_contestacao_task(this.obs.contestacao, this.obs.memoria_salvar, ResultadoStore.obs.empresaContestar.uf, devolucao, ResultadoStore.obs.empresaContestar.cnpj, ResultadoStore.obs.date_start, ResultadoStore.obs.date_end, this.obs.cnpj_memoria)

      ResultadoStore.consulta_resultados_calculo()

      this.props.onClose();

    } catch (e) { ResultadoStore.obs.working = false }

  };

  handleValidDevolucao() {

    let calcOptions: any = []

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {

      calcOptions = CalcRSStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    } else {

      calcOptions = CalcStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    }

  }

  handleSelect = (event: any, item: IMva | null) => {

    this.obs.mva_selected = item

  };

  handleScroll = (event: any) => {

    const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;

    if (bottom && this.obs.hasMore) {

      this.fetchOptions(this.obs.filter, this.obs.page + 1);

    }

  };

  async fetchOptions(inputValue: string, page: number) {

    this.setState({ loading: true })

    try {

      this.obs.filter = inputValue

      let result = await ResultadoStore.handleMvas(page, inputValue, this.props.tipo, ResultadoStore.obs.empresaContestar.uf);

      if (result.length > 0) {

        this.obs.options = [...this.obs.options, ...result];
        this.obs.page = page;
        this.obs.hasMore = true

      } else {

        this.obs.hasMore = false;

      }

    } catch (error) { }

    this.setState({ loading: false })

  }

  render() {
    let tmp_tipo = this.props.tipo.toLowerCase().replace("í", "i");
    let tmp_modelo = this.props.modelo.toLowerCase().replace("-", "");

    let calcOptions: any = []
    let calcOptionsRetro: any = []
    let calcOptionsRetencao: any = []

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    if (this.props.items.length > 0) {

      if (ResultadoStore.obs.empresaContestar.uf == "RS") {

        calcOptions = GenerateCalcOptions(CalcRSStore.validForDate(), tmp_tipo, tmp_modelo)
        calcOptionsRetro = GenerateCalcOptions(CalcRSStore.validForDateRetro(), tmp_tipo, tmp_modelo)

      } else {

        calcOptions = GenerateCalcOptions(CalcStore.validForDate(), tmp_tipo, tmp_modelo)
        calcOptionsRetro = GenerateCalcOptions(CalcStore.validForDateRetro(), tmp_tipo, tmp_modelo)

      }

    }

    calcOptionsRetencao = CalcStore.validForDate()?.map((calc: ICalc) => {

      if (calc["saida"] == true && calc[tmp_modelo] == true) {

        return calc

      }

      return null

    }).filter(option => option !== null);

    let calcText = !this.obs.calc_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_selecionado.nome.length >= 80 ? this.obs.calc_selecionado.nome.substring(0, 80) + "..." : this.obs.calc_selecionado.nome}`
    let devolucaoText = !this.obs.calc_devolucao_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_devolucao_selecionado.nome.length >= 80 ? this.obs.calc_devolucao_selecionado.nome.substring(0, 80) + "..." : this.obs.calc_devolucao_selecionado.nome}`

    return (
      <>
        <Dialog
          isOpen={true}
          onClose={() => this.props.onClose()}
          className="modal-contestacao"
        >
          <div className={Classes.DIALOG_HEADER}>
            <div style={{ display: "flex", width: "100%" }}>
              <h2 className="title-no-bottom">Contestar Cálculo</h2>
              {this.obs.isDevolucao && tmp_tipo.toLocaleLowerCase() == "entrada" && AppStore.obs1.selectedEmpresa.simples_nacional && (tmp_modelo.toLowerCase() == "nfe" || tmp_modelo.toLowerCase() == "nfce") &&
                <Switch
                  label={"Aplicar retenção na saída?"}
                  checked={this.obs.aplicar_retencao}
                  onChange={(e: any) => this.obs.aplicar_retencao = e.target.checked}
                  style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
                />
              }
            </div>
          </div>
          <div className={Classes.DIALOG_BODY}>
            <HTMLTable
              className="table table-hover dataTable"
              style={{ width: "100%" }}
            >
              <tbody>
                {!this.obs.alterar_data ?
                  <>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>
                        <b style={{ color: "rgb(219, 83, 83)", fontSize: 18, marginRight: 10, }}>*</b>
                        Utilizar cálculo
                      </td>
                      <td>
                        <FormGroup className="empresaSelect produtoSelect">
                          <CalcSelect
                            items={this.obs.retroativas ? calcOptions : calcOptionsRetro}
                            itemRenderer={renderCalcs}
                            itemPredicate={filterCalcs}
                            onItemSelect={(e: ICalc) => {
                              this.obs.calc_selecionado = e
                              this.handleValidDevolucao()
                            }}
                            inputProps={{ placeholder: "Filtrar um Cálculo" }}
                            matchTargetWidth
                          >
                            <Button
                              text={calcText}
                              rightIcon="double-caret-vertical"
                              alignText={Alignment.LEFT} />
                          </CalcSelect>
                        </FormGroup>
                      </td>
                      <td>
                        <Switch
                          label={this.obs.retroativas ? "Cálculo Vigentes" : "Cálculos Retroativos"}
                          checked={this.obs.retroativas}
                          onChange={(e: any) => this.obs.retroativas = e.target.checked}
                          style={{ marginTop: "10px" }}
                        />
                      </td>
                    </tr>
                    {this.obs.aplicar_retencao &&
                      <>
                        <tr>
                          <td style={{ verticalAlign: "middle" }}>Cálculo da retenção</td>
                          <td>
                            <FormGroup className="empresaSelect produtoSelect">
                              <CalcSelect
                                items={calcOptionsRetencao}
                                itemRenderer={renderCalcs}
                                itemPredicate={filterCalcs}
                                onItemSelect={(e: ICalc) => this.obs.calc_devolucao_selecionado = e}
                                inputProps={{ placeholder: "Filtrar um Cálculo" }}
                                matchTargetWidth
                              >
                                <Button
                                  text={devolucaoText}
                                  rightIcon="double-caret-vertical"
                                  alignText={Alignment.LEFT} />
                              </CalcSelect>
                            </FormGroup>
                          </td>
                          <td />
                        </tr>
                      </>
                    }
                    {this.obs.mudar_mva ?
                      <tr>
                        <td style={{ verticalAlign: "middle" }}>
                          <b style={{ color: "rgb(219, 83, 83)", fontSize: 18, marginRight: 10, }}>*</b>
                          Utilizar Produto
                        </td>

                        <td>
                          <Autocomplete
                            disablePortal
                            size="small"
                            options={this.obs.options}
                            onInputChange={(event, value) => {
                              this.obs.options = [];
                              this.obs.page = 1;
                              this.obs.hasMore = true;
                              this.obs.fetchOptions(value, 1);
                            }}
                            getOptionLabel={(option) => `${option.produto_ncm} - ${option.produto_cest} - ${option.produto_desc}` || ""}
                            filterOptions={(x) => x}
                            onChange={this.handleSelect}
                            ListboxProps={{ onScroll: this.handleScroll }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Selecione o Produto"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {this.state.loading ? <CircularProgress color="inherit" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            value={this.obs.mva_selected}
                            className='select-empresas'
                            clearOnBlur
                            clearOnEscape
                            blurOnSelect
                            noOptionsText="Não foram encontrados resultados!"
                          />
                        </td>
                        <td>
                          <Switch
                            label={this.obs.mudar_mva ? "Mudando produto" : "Não"}
                            checked={this.obs.mudar_mva}
                            onChange={(e: any) => this.obs.mudar_mva = e.target.checked}
                            style={{ marginTop: "10px" }}
                          />
                        </td>
                      </tr>
                      :
                      <tr>
                        <td style={{ verticalAlign: "middle" }}>Mudar MVA</td>
                        <td>
                          <Switch
                            innerLabelChecked="Sim"
                            innerLabel="Não"
                            checked={this.obs.mudar_mva}
                            onChange={(e: any) => this.obs.mudar_mva = e.target.checked}
                            style={{ marginTop: "10px" }}
                          />
                        </td>
                        <td></td>
                      </tr>
                    }
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>
                        Alterar data
                      </td>
                      <td>
                        <DateInput
                          {...getMomentFormatter("DD/MM/YYYY")}
                          locale="pt-br"
                          dayPickerProps={dayPickerProps}
                          value={this.obs.contestacao.contestacao_data
                            ? new Date(this.obs.contestacao.contestacao_data)
                            : null}
                          onChange={val => this.obs.contestacao.contestacao_data = val}
                          placeholder="DD/MM/AAAA"
                          canClearSelection
                        />
                      </td>
                      <td />
                    </tr>
                  </>

                  :

                  <tr>
                    <td style={{ verticalAlign: "middle" }}>
                      <b style={{ color: "rgb(219, 83, 83)", fontSize: 18, marginRight: 10, }}>*</b>
                      Alterar data
                    </td>
                    <td>
                      <DateInput
                        {...getMomentFormatter("DD/MM/YYYY")}
                        locale="pt-br"
                        dayPickerProps={dayPickerProps}
                        value={this.obs.contestacao.contestacao_data
                          ? new Date(this.obs.contestacao.contestacao_data)
                          : null}
                        onChange={val => this.obs.contestacao.contestacao_data = val}
                        placeholder="DD/MM/AAAA"
                        canClearSelection
                      />
                    </td>
                    <td />
                  </tr>

                }
                <tr>
                  <td style={{ verticalAlign: "middle" }}>
                    <b
                      style={{
                        color: "rgb(219, 83, 83)",
                        fontSize: 18,
                        marginRight: 10,
                      }}
                    >
                      *
                    </b>
                    Motivo
                  </td>
                  <td>
                    <InputGroup
                      value={this.obs.contestacao.motivo}
                      onChange={(e: any) =>
                        this.obs.contestacao.motivo = e.target.value}
                    />
                  </td>
                  <td />
                </tr>
              </tbody>
            </HTMLTable>

            <MDBRow>
              <MDBCol md="3">
                <div className="consteta-produto-lote-btn">
                  <Switch
                    label={"Salvar contestação"}
                    alignIndicator={Alignment.RIGHT}
                    innerLabelChecked="Sim"
                    innerLabel="Não"
                    disabled={this.obs.alterar_data}
                    checked={this.obs.memoria_salvar}
                    onChange={(e: any) => this.obs.memoria_salvar = e.target.checked}
                  />
                  <Switch
                    label={"Apenas data"}
                    alignIndicator={Alignment.RIGHT}
                    innerLabelChecked="Sim"
                    innerLabel="Não"
                    onChange={(e: any) => this.handleContestarData(e.target.checked)}
                  />
                  {this.obs.memoria_salvar &&
                    <div style={{ display: "flex" }}>
                      <label style={{ width: 135 }}>
                        Memória CNPJ
                        <AppIcon
                          name="help"
                          className="pulse-notification-pgdas"
                          color="blue"
                          style={{ cursor: "pointer", marginLeft: 5 }}
                          onClick={(e) => this.obs.open_ajuda = true}
                        />
                      </label>
                      <Switch
                        alignIndicator={Alignment.RIGHT}
                        innerLabelChecked="Sim"
                        innerLabel="Não"
                        disabled={this.obs.alterar_data}
                        checked={this.obs.cnpj_memoria}
                        onChange={(e: any) => this.obs.cnpj_memoria = e.target.checked}
                      />
                    </div>
                  }
                </div>
              </MDBCol>

              <MDBCol md="9" style={{ position: "relative"}}>
                <div className="consteta-produto-lote-btn" style={{position: "absolute", bottom: 0, right: 0, textAlign: "right" }}>
                  <Button text="Cancelar" onClick={() => this.props.onClose()} style={{ marginRight: 10, height: "35px" }} />
                  <Button
                    text="Contestar"
                    intent="primary"
                    onClick={this.handleConfirm}
                    loading={ResultadoStore.obs.working}
                    style={{ height: "35px" }}
                    disabled={this.handleValid()}
                  />
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </Dialog >

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`

          <b>Memória CNPJ:</b><br /><br />

          <b>Ativada</b> – O sistema valida o CNPJ de origem nas entradas e o CNPJ de destino nas saídas para salvar a Memória de Cálculo.<br /><br />

          <b>Desativada</b> – O sistema não realiza a validação de CNPJ, permitindo salvar a Memória de Cálculo sem informações de CNPJ.<br /><br />

        `} />

      </>
    );
  }
}
